import React from 'react';
import { SvgVirtualConnectionTable, SvgVirtualConnectionTableExtract } from '../../../../../../gen-src/icons';

export function VirtualConnectionTableTypeIcon(props: { isExtracted: boolean }): JSX.Element {
  if (props.isExtracted) {
    return <SvgVirtualConnectionTableExtract />;
  } else {
    return <SvgVirtualConnectionTable />;
  }
}
